/**
 * Converts hex to space-separated RGB string for use with CSS `rgb()` and opacity.
 *
 * @param hex - Hex color string (e.g. '#e63946')
 * @returns Space-separated RGB string (e.g. '230 57 70')
 *
 * @example
 * hexToRgbString('#e63946') // '230 57 70'
 */
export function hexToRgbString(hex: string): string {
  const n = parseInt(hex.replace('#', ''), 16)
  return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`
}

/**
 * Validates whether a string is a valid hex color.
 * Accepts 3, 6, or 8 character hex values (with or without #).
 *
 * @param color - The color string to validate
 * @returns `true` if the color is a valid hex, `false` otherwise
 *
 * @example
 * isValidHexColor('#e63946')   // true
 * isValidHexColor('#fff')      // true
 * isValidHexColor('#ffffff00') // true  (with alpha)
 * isValidHexColor('e63946')    // false (missing #)
 * isValidHexColor('rgb(0,0,0') // false
 */
export function isValidHexColor(color: string): boolean {
  return /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/.test(color)
}
